<template>
  <div class="box">
    <div class="lBox">
    <ul>
      <li v-for="list in lBoxArr" :key="list.id">{{list}}</li>
    </ul>
    </div>
    <div class="rBox">
     <div class="setBox">
       <div class="setting" >设置</div>
       <ul class="setList">
         <li v-for="list in setArr" :key="list.id">{{list}}</li>
       </ul>
     </div>
     <div class="login">登录</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopMenu",
  data(){
    return{
    lBoxArr:['新闻', 'hao123', '地图', '贴吧', '视频', '图片', '网盘', '文库', '更多'],
    setArr:['搜索设置', '高级搜索', '关闭预测', '隐私设置', '隐藏热搜']
  }
  },


}
</script>

<style scoped lang="scss" >

.box{
  height: 50px;
  /*background: #42b983;*/
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.lBox{
  width: 600px;
  height: 40px;
}
.lBox ul{
  width: 500px;
  height: 40px;
  /*background: aliceblue;*/
  display: flex;
  justify-content:space-evenly;
  align-items: center;
}
li{
  font-size: 13px;
}
.rBox{
  width: 180px;
  height: 40px;
  /*background: aliceblue;*/
  font-size: 13px;
  display: flex;
  .setBox{
    width: 80px;
    height: 20px;
  }
}

.setting{
  height: 40px;
  line-height: 20px;
  text-align: center;
  padding-right: 35px;

}
.login{
  width: 40px;
  height: 20px;
  background: #315efb;
  border-radius: 5px;
  line-height: 20px;
  color: #ffffff;
  text-align: center;
}
.setList{
  width: 80px;
  height: 120px;
  display: none;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  /*background: #42b983;*/
  margin: -15px;
  box-shadow: 0 5px 10px rgba(0,0,0,0.1);
  position: absolute;
  z-index: 20;
}

li:hover,.setting:hover{
  color:#315efb;
  cursor: pointer;
}
.setBox:hover .setList{
  display: flex;
}

</style>